import { BillingMode, InvoiceStatus, InvoiceType } from '../../../../../../services/exports/Constants';

export default {
  title: 'Facturi',
  form: {
    title: 'Solicitați o plată nouă',
    company: {
      label: 'Restaurant',
    },
    billing_mode: {
      label: 'Sursă de facturare',
    },
    billing_anchor: {
      label: 'Începeți facturarea la',
    },
    items: {
      label: 'Articole',
    },
    name: {
      label: 'Nume',
      placeholder: '1000x Flyere',
    },
    net_amount: {
      label: 'Sumă (NET)',
      tax_breakdown: '+{{tax}} TVA = {{total}}',
    },
  },
  fields: {
    id: 'ID',
    company: 'Restaurant',
    name: 'Nume/Număr',
    billing_mode: 'Sursă de facturare',
    type: 'Tip',
    status: 'Stare',
    amount: 'Sumă (Brut)',
    created_at: 'Creat',
    billing_anchor: 'Facturare din',
    invoice: 'Factură',
  },
  billing_modes: {
    [BillingMode.Stripe]: 'Metodă de plată',
    [BillingMode.InternalInvoicing]: 'Vânzări',
  },
  types: {
    [InvoiceType.Manual]: 'Manual',
    [InvoiceType.SetupFee]: 'Taxă de configurare',
    [InvoiceType.Subscription]: 'Abonament',
  },
  statuses: {
    [InvoiceStatus.Pending]: 'În așteptare',
    [InvoiceStatus.Processing]: 'În procesare',
    [InvoiceStatus.Paid]: 'Plătit',
    [InvoiceStatus.PartiallyRefunded]: 'Parțial rambursat',
    [InvoiceStatus.Refunded]: 'Rambursat',
    [InvoiceStatus.Failed]: 'Eșuat',
  },
  modals: {
    invoice_creation_confirmation: {
      title: 'Sigur doriți să creați o factură de {{amount}} NET pentru {{company}} din {{billingMode}}?',
    },
    invoice_recharge_confirmation: {
      title: 'Sunteți sigur?',
      description:
        '<strong>{{company}}</strong> va fi debitat cu <strong>{{amount}} brut + penalitate pentru eșec dacă este cazul</strong> din metoda de plată principală pentru factura {{details}}',
      recharge_failed: {
        title: 'Stripe a refuzat plata',
        convert_hint:
          'Puteți colecta această factură din vânzările restaurantului. Factura Stripe va fi anulată, iar suma restantă va fi dedusă din plățile viitoare.',
      },
    },
  },
  buttons: {
    show_transfers: 'Afișați transferurile',
    hide_transfers: 'Ascundeți transferurile',
    create: 'Creați',
    download_pdf: 'Descărcați PDF',
    open_payment_page: 'Deschideți pagina de plată',
    open_invoice_page: 'Deschideți detalii factură',
    add_item: 'Adăugați articol',
    convert_to_internal_billing: 'Colectați din vânzări',
    recharge_invoice: 'Reîncărcați factura',
  },
  toasts: {
    failed_to_load_data: 'Încărcarea datelor a eșuat',
    failed_to_create_invoice: 'Crearea facturii a eșuat!',
    invoice_got_created: 'Factura a fost creată!',
    invoice_got_recharged: 'Factura a fost reîncărcată. Noua plată este în procesare!',
    failed_to_recharge_invoice: 'Reîncărcarea facturii a eșuat!',
    invoice_got_converted_to_internal_billing:
      'Factura a fost convertită la facturare din vânzări. Suma restantă va fi dedusă din plățile viitoare.',
    failed_to_convert_invoice_to_internal_billing: 'Conversia facturii la facturare din vânzări a eșuat!',
  },
};
